<div class="modal fade auth-modal" id="rate-midwife" data-keyboard="false"
 tabindex="-1" aria-hidden="true" *ngIf="midwife">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">Rate your experience</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div class="d-flex flex-column text-center mx-3">
                    <img class="profile-img my-1" [src]="midwife.profileImage">
                    <span class="mt-2 modal-text">Rate the care provided by</span>
                    <span class="mt-1 profile-name">{{midwife.name}}</span>
                </div>
                <div class="d-flex flex-row justify-content-center mt-3 mb-2 rating">
                    <i class="fas fa-star mx-1 star d-none"></i>
                    <i class="fas fa-star mx-1 star" [ngClass]="{'active': selectedStar==5}" (click)="selectStar(5)"></i>
                    <i class="fas fa-star mx-1 star" [ngClass]="{'active': selectedStar==4}" (click)="selectStar(4)"></i>
                    <i class="fas fa-star mx-1 star" [ngClass]="{'active': selectedStar==3}" (click)="selectStar(3)"></i>
                    <i class="fas fa-star mx-1 star" [ngClass]="{'active': selectedStar==2}" (click)="selectStar(2)"></i>
                    <i class="fas fa-star mx-1 star" [ngClass]="{'active': selectedStar==1}" (click)="selectStar(1)"></i>
                </div>
                <div class="d-flex flex-column mx-3">
                    <span class="input-label mt-3 mb-2">Write your review</span>
                    <textarea class="form-control form-control-sm" rows="5" [(ngModel)]="reviewText"></textarea>
                </div>
                <div class="d-flex flex-row justify-content-end mt-4 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clear()">Not Now</button>
                    <button class="btn btn-theme" [disabled]="reviewText.length < 10" (click)="createReview()">Submit Review</button>
                </div>
            </div>
        </div>
    </div>
</div>